import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X5LessonStore} from '../X5LessonStore';

@observer
export class ReorderPagesControls extends React.Component<{ store: X5LessonStore }> {
  render() {
    const {store} = this.props;

    if (store.reorder === null)
      return null;

    const reorder = store.reorder;
    const isPending = reorder.save?.isPending === true;

    return (<>
      <div className="row justify-content-end" key="reorder-actions">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeReorderPages}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={reorder.save} align="right"/>
    </>);
  }
}
